<template>
  <div class="component-collection-card music flex-column mx-1 item" :style="{backgroundImage: 'url(' + fileUrl(item.imageUrl) + ')'}">
    <b-card
      overlay
      tag="b-link"
      :title="item.title"
      :img-src="fileUrl(item.imageUrl+'?w=300')"
      :img-alt="item.title"
      :to="'/collection/'+item.id"
      img-top
      class="no-underline border-0 text-center text-white text-shadow"
      title-tag="h3"
      body-class="d-flex align-items-end justify-content-center"
    />
    <img src="@/assets/icons/compact-disc.svg" class="disc">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MusicCollectionCard',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    })
  }
}
</script>
